import { navigate as gatsbyNavigate } from '@intl'

export const CATEGORY_NAVIGATION_DELAY = 300
export const CATEGORY_ENTER_DELAY = 500

export const navigateWithTransition = (to, options = {}) => {
  const { withSlideAnimation = false, direction = 'next' } = options

  if (withSlideAnimation && typeof window !== 'undefined') {
    const timestamp = Date.now()
    const transitionData = {
      animate: true,
      direction,
      timestamp,
      transitionAt:
        timestamp + CATEGORY_NAVIGATION_DELAY + CATEGORY_ENTER_DELAY,
    }

    sessionStorage.setItem('pageTransition', JSON.stringify(transitionData))

    setTimeout(() => {
      gatsbyNavigate(to, {
        ...options,
        withSlideAnimation: undefined,
        direction: undefined,
      })
    }, CATEGORY_NAVIGATION_DELAY)
  } else {
    return gatsbyNavigate(to, options)
  }
}
